import { ISvgCircleStyle } from '../models/index.js';
export const svgCircleStyle: ISvgCircleStyle = {
	children: {
		wrapper: {},
	},
};
